export interface ProgramStatus {
  status: boolean;
}

export function inactiveProgramStatus(): ProgramStatus {
  return{
    status: false,
  }
}
